const PARKING_SEARCH_CRITERIA_VALIDATIONS = {
  plateState: value => {
    if (!value) {
      return "Please select a state."
    }
    return false
  },
  plateNumber: value => {
    if (!value || !value.trim().length) {
      return "Please enter a valid plate number."
    }
    return false
  },
  ticketId: value => {
    if (!value.match(/^\d{10}$/g)) {
      return "Ticket number needs to be 10 digits."
    }
    return false
  }
}

export default PARKING_SEARCH_CRITERIA_VALIDATIONS
